// redux/notificationSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    open: false,
    severity: "error", // 'success' | 'error' | 'warning' | 'info'
    message: "",
};

const notificationStore = createSlice({
    name: "notification",
    initialState,
    reducers: {
        showNotification: (state, action) => {
            const { severity = "error", data = "" } = action.payload;
            let message = "";
            if (data.response && data.response.data) {
                message = JSON.stringify(data.response.data);
            } else if (data.message) {
                message = data.message;
            } else {
                message = data;
            }
            state.open = true;
            state.severity = severity;
            state.message = message;
            console.log(`${severity} encontered:`, message);
        },
        hideNotification: (state) => {
            state.open = false;
            state.message = "";
        },
    },
});

export const { showNotification, hideNotification } = notificationStore.actions;

export default notificationStore.reducer;
